import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isSmsLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.CREATE_SMS_ENTITY:
          return Object.assign({}, state, { isSmsLoading: true });
        case actionTypes.GET_SMS_LIST:
          return Object.assign({}, state, { isSmsLoading: true });
        case actionTypes.SAVE_SMS:
          return Object.assign({}, state, { isSmsLoading: true });
        case actionTypes.DELETE_SMS:
          return Object.assign({}, state, { isSmsLoading: true });
        case actionTypes.EDIT_SMS:
          return Object.assign({}, state, { isSmsLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.CREATE_SMS_ENTITY:
          return Object.assign({}, state, { isSmsLoading: false });
        case actionTypes.GET_SMS_LIST:
          return Object.assign({}, state, { isSmsLoading: false });
        case actionTypes.SAVE_SMS:
          return Object.assign({}, state, { isSmsLoading: false });
        case actionTypes.DELETE_SMS:
          return Object.assign({}, state, { isSmsLoading: false });
        case actionTypes.EDIT_SMS:
          return Object.assign({}, state, { isSmsLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
